/**
 * Legacy module — preserved empty so `acme.common.service.posConfigImages`
 * keeps resolving. Real impl (internal sub-service of PosConfigService, not
 * downgrade-registered):
 *   apps/b2b-frontend/app/core/pos-config/images/pos-config-images.service.ts
 * Wave 3 item #17.
 */
angular.module('acme.common.service.posConfigImages', []);
